module.exports = __webpack_public_path__ + "img/ordermgt.191e50a5.png";